module.exports = __webpack_public_path__ + "static/media/monitor_trade.ba0a3696.png";